import React, { useRef } from 'react';
import { Animated, TouchableOpacity, ViewStyle, StyleProp } from 'react-native';
import { createPressAnimation } from '../utils/animations';

interface PressableCardProps {
  children: React.ReactNode;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
  pressedScale?: number;
  hapticFeedback?: boolean;
  disabled?: boolean;
}

export const PressableCard: React.FC<PressableCardProps> = ({
  children,
  onPress,
  style,
  pressedScale = 0.97,
  hapticFeedback = true,
  disabled = false,
}) => {
  const scaleAnim = useRef(new Animated.Value(1)).current;
  const { pressIn, pressOut } = createPressAnimation(scaleAnim, pressedScale);

  const handlePressIn = () => {
    if (!disabled) {
      pressIn();
      if (hapticFeedback) {
        // Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
      }
    }
  };

  const handlePressOut = () => {
    if (!disabled) {
      pressOut();
    }
  };

  const handlePress = () => {
    if (!disabled && onPress) {
      if (hapticFeedback) {
        // Haptics.selectionAsync();
      }
      onPress();
    }
  };

  return (
    <TouchableOpacity
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
      onPress={handlePress}
      activeOpacity={1}
      disabled={disabled}
    >
      <Animated.View
        style={[
          style,
          {
            transform: [{ scale: scaleAnim }],
          },
        ]}
      >
        {children}
      </Animated.View>
    </TouchableOpacity>
  );
};
